export type DisputeRequiredFieldKey =
  | "purchaserId"
  | "deductionTypeId"
  | "checkNumber"
  | "invoiceNumber"
  | "deductionAmount"
  | "remittanceNetAmount"
  | "backupDocument";

export const DISPUTE_REQUIRED_FIELD_LABELS: Record<DisputeRequiredFieldKey, string> = {
  purchaserId: "Purchaser",
  deductionTypeId: "Deduction Type",
  checkNumber: "Check Number",
  invoiceNumber: "Invoice / Claim Number",
  deductionAmount: "Deduction Amount",
  remittanceNetAmount: "Remittance Net Amount",
  backupDocument: "Backup Document",
};

export interface DisputeRequiredDataInput {
  deductionId: number;
  remittanceItemId: number;
  purchaserKey: string;
  purchaserId: number;
  deductionTypeId: number;
  checkNumber: string;
  invoiceNumber: string;
  deductionAmount: number | null | undefined;
  remittanceNetAmount: number | null | undefined;
  isDocumentsRequired: boolean;
  backupDocumentCount: number;
}

const isBlankString = (value: string | null | undefined): boolean => {
  return !value || value.trim().length === 0;
};

const isMissingPositiveId = (value: number | null | undefined): boolean => {
  return !value || value <= 0;
};

const isMissingAmount = (value: number | null | undefined): boolean => {
  return value === null || value === undefined || value === 0;
};

export const getMissingDisputeRequiredFields = (input: DisputeRequiredDataInput): DisputeRequiredFieldKey[] => {
  const missing: DisputeRequiredFieldKey[] = [];

  if (isMissingPositiveId(input.purchaserId)) {
    missing.push("purchaserId");
  }
  if (isMissingPositiveId(input.deductionTypeId)) {
    missing.push("deductionTypeId");
  }
  if (isBlankString(input.checkNumber)) {
    missing.push("checkNumber");
  }
  if (isBlankString(input.invoiceNumber)) {
    missing.push("invoiceNumber");
  }
  if (isMissingAmount(input.deductionAmount)) {
    missing.push("deductionAmount");
  }
  if (input.remittanceNetAmount === null || input.remittanceNetAmount === undefined) {
    missing.push("remittanceNetAmount");
  }
  if (input.isDocumentsRequired && input.backupDocumentCount === 0) {
    missing.push("backupDocument");
  }

  return missing;
};

export const formatMissingDisputeFieldsMessage = (missingKeys: DisputeRequiredFieldKey[]): string => {
  const fieldLines = missingKeys.map(key => `• ${DISPUTE_REQUIRED_FIELD_LABELS[key]}`).join("\n");

  return `We can't process this dispute yet - the following information is required:\n\n${fieldLines}\n\nPlease complete this field and try again.`;
};
